import React from 'react'
import { Progress as AntProgress } from 'antd'
import './Progress.scss'
import _ from 'lodash'

const Progress = (props) => {
  const adapter = {
    format: (percent) => (percent ? (percent / 100).toFixed(2) : '')
  }

  const defaults = {
    strokeWidth: 25
  }

  if (props.info) {
    defaults.showInfo = false
  }

  const options = _.defaultsDeep({}, adapter, props, defaults)

  return (
    <div className='pan-progress'>
      {!_.isNil(props.info) && (
        <div className='pan-progress-text'>{props.info}</div>
      )}
      <AntProgress {...options} />
    </div>
  )
}

Progress.AntProgress = AntProgress
export default Progress
